import { setWasmUrl } from "@lottiefiles/dotlottie-react";

/**
 * Where the dotlottie player WASM is served from.
 *
 * On web, lottie-react-native renders through @lottiefiles/dotlottie-react,
 * and dotlottie-web fetches its WASM from cdn.jsdelivr.net unless told
 * otherwise. AutumnLoader plays a Lottie, so every page that shows a loader
 * (the patient portal's /deposit and Medicare token pages included) made a
 * third-party request before the patient had answered the tracking consent
 * banner: a GDPR finding.
 *
 * We host it ourselves instead, the same way as canvaskit.wasm
 * (Common/Skia/utils/skiaWeb.ts). `postinstall` runs `yarn setup-dotlottie-web`,
 * which copies the *installed* `dotlottie-player.wasm` into `web/static/js/`,
 * and @expo/webpack-config ships `web/` into `web-build/`. Absolute and
 * same-origin: `output.publicPath` is always "/".
 *
 * dotlottie-web retries from unpkg.com only if this URL fails to load, which
 * `yarn verify-dotlottie-wasm` (run by the web builds) guards against.
 */
export const DOTLOTTIE_WASM_URL = "/static/js/dotlottie-player.wasm";

/**
 * Points dotlottie at the self-hosted WASM. Call before the first Lottie
 * renders; the WASM is only fetched when the first animation mounts, so
 * setting it at module load is early enough. Idempotent.
 */
export const configureDotLottieWasm = (): void => {
  setWasmUrl(DOTLOTTIE_WASM_URL);
};
